
/**
 * A message applicable to a request message set.
 */
export abstract class RequestMessage {
}
